import React from 'react';
import { slugify } from '../components/slugify';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import ScrollToTop from 'react-scroll-up';
import BackgroundImage from 'react-background-image-loader';
import ItemGrid from '../components/isotopify.js';
import IsotopeFilterLinks from '../components/isofilter.js';

var BaseHref = 'http://46.4.51.11:1337'



const LeistungenPage = ({ data }) => (

    <div>
        <Helmet
            bodyAttributes={{
                class: 'projekte'
            }}
        />
        <ScrollToTop
            showUnder={160}
            style={
                {
                    position: 'fixed',
                    bottom: 80,
                    right: 0,
                    cursor: 'pointer',
                    transitionDuration: '0.2s',
                    transitionTimingFunction: 'linear',
                    transitionDelay: '0s',
                    zIndex: '999'
                }
            }
        >
            <button className="slick-arrow slick-up"></button>
        </ScrollToTop>
        <h1>Projekte</h1>
        <div>
            <IsotopeFilterLinks />
        </div>


        <div className="grid-container">
            <ItemGrid>
                <div className="grid-sizer"></div>
                {data.allStrapiReferenz.edges.map((document) => {
                    let varImg = document.node.Ref_Images;

                    var ImgDiv;
                    const isFeature = (document.node.Featured__2x_Size_ == true);

                    if (varImg == 0) {
                        ImgDiv = (
                                <div className={'grid-item ' + slugify(document.node.Ref_Category) + ''} key={document.node.id}>
                                    <Link key={"link0" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}>
                                        <BackgroundImage className="tileBG" src={data.strapiMetadata.placeholder_img.childImageSharp.sizes.src} placeholder={data.strapiMetadata.placeholder_img.childImageSharp.sizes.src}> </BackgroundImage>
                                    </Link>
                                    <div key={"div" + document.node.id} className="grid-content">
                                        <Link key={"link1" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}><h3 key={"h" + document.node.id} className="ref_title">{document.node.Title}</h3></Link>
                                        <Link key={"link2" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}><p key={"p" + document.node.id} className="ref_description">{document.node.Ref_Description_Intro}</p></Link>
                                        <Link className="tags" to={`/leistungen-arbeitsgebiete/${slugify(document.node.Ref_Category)}`}>{document.node.Ref_Category}</Link>
                                    </div>
                                </div>
                        )
                    } else {

                        // if images are available 
                        // check if featured …

                        {
                            isFeature ? (
                                ImgDiv = (
                                        <div className={'grid-item grid-item--width2 ' + slugify(document.node.Ref_Category) + ''} key={document.node.id}>
                                            <Link key={"link00" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}>
                                                <Img sizes={document.node.Ref_Img_1.childImageSharp.sizes} />
                                            </Link>
                                            <div key={"div" + document.node.id} className="grid-content">
                                                <Link key={"link11" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}><h3 key={"h" + document.node.id} className="ref_title">{document.node.Title}</h3></Link>
                                                <Link key={"link22" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}> <p key={"p" + document.node.id} className="ref_description">{document.node.Ref_Description_Intro}</p></Link>
                                                <Link className="tags" to={`/leistungen-arbeitsgebiete/${slugify(document.node.Ref_Category)}`}>{document.node.Ref_Category}</Link>
                                            </div>
                                        </div>
                                )

                                // or not …

                            ) : (
                                    ImgDiv = (
                                            <div className={'grid-item ' + slugify(document.node.Ref_Category) + ''} key={document.node.id}>
                                                <Link key={"link000" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}> 
                                                    <Img sizes={document.node.Ref_Img_1.childImageSharp.sizes} />
                                                </Link>
                                                <div key={"div" + document.node.id} className="grid-content">
                                                    <Link key={"link111" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}><h3 key={"h" + document.node.id} className="ref_title">{document.node.Title}</h3></Link>
                                                    <Link key={"link222" + document.node.id} to={`/projekte/${slugify(document.node.Ref_Category)}/${slugify(document.node.Title)}`}><p key={"p" + document.node.id} className="ref_description">{document.node.Ref_Description_Intro}</p></Link>
                                                    <Link className="tags" to={`/leistungen-arbeitsgebiete/${slugify(document.node.Ref_Category)}`}>{document.node.Ref_Category}</Link>
                                                </div>
                                            </div>
                                    )
                                )
                        }

                    }
                    // return image block
                    return ImgDiv
                })
                }
            </ItemGrid>
        </div>
    </div>

)

export default LeistungenPage

export const pageQuery = graphql`  
  query ReferenzenAndMetadata {
    allStrapiReferenz(sort: { fields: [updatedAt], order: DESC }) {
      edges {
        node {
          id
          Title
          Category
          Ref_Description_Intro
          Ref_Description_Fulltext
          Ref_Category
          Ref_Leistungen
          Ref_Fakten
          Ref_Kunde
            Ref_Img_1 {
                childImageSharp{
                    sizes(quality: 80) {
                    base64
            tracedSVG
            aspectRatio
            src
            srcSet
            srcWebp
            srcSetWebp
            sizes
            originalImg
            originalName
          }
                }
          }
          Ref_Images {
             url
          }
          Featured__2x_Size_
        }
      }
    },
    
      strapiMetadata{
        SiteTitle
        Keywords
        placeholder_img{
        childImageSharp{
            sizes{
            src
            }
        }
        }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/projekte.js